module.exports = __webpack_public_path__ + "static/media/waiting-dog.f229ad44.png";